import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CompanyDto } from '../../models/api/companyDto';
import { CompanyDetailsDto } from '../../models/api/companyDetailsDto';
import { CreateCompanyRequest } from '../../models/api/createCompanyRequest';
import { CompanySearchRequest } from '../../models/api/companySearchRequest';
import { PaginatedResponse } from '../../models/paginatedResponse';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  private apiUrl = `${environment.apiUrl}/companies`;

  constructor(private http: HttpClient) {}

  /**
   * Create a new company with initial details
   */
  create(request: CreateCompanyRequest): Observable<CompanyDetailsDto> {
    return this.http.post<CompanyDetailsDto>(this.apiUrl, request);
  }

  /**
   * Delete a company and all related data
   */
  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  /**
   * Search companies with pagination and filtering
   */
  search(request: CompanySearchRequest): Observable<PaginatedResponse<CompanyDto>> {
    return this.http.post<PaginatedResponse<CompanyDto>>(`${this.apiUrl}/search`, request);
  }

  /**
   * Export companies to CSV based on search criteria
   */
  exportCompaniesToCsv(request: CompanySearchRequest): Observable<Blob> {
    return this.http.post(`${this.apiUrl}/search/export`, request, {
      responseType: 'blob'
    });
  }
}
